import { Stack, Typography } from '@mui/joy';
import { PencilSimpleLine, TrashSimple } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';

import { isPromotedSingleChild } from 'core/utils';
import {
  RemoveCorporatePartCostButton,
  UpsertCorporatePartCostButton,
} from 'corporate/components/UpsertCorporatePartCost';
import { CorporatePartCostStatus } from 'corporate/enums';
import { ICorporatePart, ICorporatePartCostListItem } from 'corporate/types';
import { Color, Direction, Level } from 'theme/enums';

import { IFlatCostRow } from '../utils';

interface IProps extends ICellRendererParams<IFlatCostRow> {
  corporatePart: Partial<ICorporatePart>;
}

const iconSx = { cursor: 'pointer' };

const resolveRecord = (
  data: IFlatCostRow | undefined,
  node: ICellRendererParams['node']
): ICorporatePartCostListItem | undefined => {
  if (node?.group) {
    return node.allLeafChildren?.[0]?.data?._record;
  }

  return data?._record;
};

export const ActionsCell = ({ corporatePart, data, node }: IProps) => {
  const isGroup = !!node?.group;
  const isPromoted = isPromotedSingleChild({ node });

  if (!isGroup && !isPromoted) {
    return null;
  }

  const record = resolveRecord(data, node);

  const isEditable =
    record?.status === CorporatePartCostStatus.ACTIVE ||
    record?.status === CorporatePartCostStatus.PENDING;

  if (!isEditable || !record) {
    return null;
  }

  return (
    <Stack direction={Direction.ROW} gap={1}>
      <UpsertCorporatePartCostButton
        corporatePart={corporatePart}
        cost={record}
        buttonElement={
          <Typography color={Color.PRIMARY} level={Level.BODY_SM} sx={iconSx}>
            <PencilSimpleLine />
          </Typography>
        }
      />

      <RemoveCorporatePartCostButton
        costs={[record]}
        buttonElement={
          <Typography color={Color.DANGER} level={Level.BODY_SM} sx={iconSx}>
            <TrashSimple />
          </Typography>
        }
      />
    </Stack>
  );
};
